var React = require('react');

function SortIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.894 1.553a1 1 0 0 0-1.789 0l-4 8a1 1 0 0 0 1.79.894L15.617 9h4.764l.723 1.447a1 1 0 0 0 1.79-.894l-4-8zM19.382 7 18 4.236 16.618 7h2.764zM5 4v13.25L3.05 15.305A.97.97 0 0 0 1.68 16.68L6 21l4.321-4.32a.97.97 0 0 0-1.371-1.374l-1.95 1.943V4a1 1 0 1 0-2 0zm8 11a1 1 0 0 0 1 1h4.586l-5.293 5.293A1 1 0 0 0 14 23h7a1 1 0 1 0 0-2h-4.586l5.293-5.293A1 1 0 0 0 21 14h-7a1 1 0 0 0-1 1z","fill":"#fff"}));
}

SortIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SortIcon;

SortIcon.default = SortIcon;
